import React from "react"
import styles from "../../styles/header.module.styl"
import illustration from "../../assets/svg/header-icon.png"

export default () => (
  <img className={styles.illustration} src={illustration} alt="illustration" />
)
